/**
 * Created by KryQ on 2017-06-23.
 */
import React, { Component } from 'react';
import {Alert, Form, FormGroup, Label, Input, Button} from 'reactstrap';
var axios = require('axios');

export default class LoginPrompt extends Component {
    constructor (props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            submitButtonValue: 'Zaloguj',
            alert: {
                visible: false,
                value: 'Błąd logowania',
                type: 'danger'
            }
        };

        this.updateField = this.updateField.bind(this);
        this.loginAction = this.loginAction.bind(this);
        this.onDismissAlert = this.onDismissAlert.bind(this);
    }

    updateField (event) {
        switch (event.target.id) {
            case 'email': this.setState({email: event.target.value}); break;
            case 'password': this.setState({password: event.target.value}); break;
            default: return;
        }
    }

    loginAction () {
        this.setState({submitButtonValue: 'logowanie...'});

        axios({
            method: 'post',
            url: this.props.restIp+'/users/login',
            data: {
                email: this.state.email,
                password: this.state.password
            },
            withCredentials: true
        }).then(function (response) {
            let msg = '';

            switch (response.data.msg) {
                case 'logged_in': msg = 'Zalogowano'; window.location.reload(); break;
                case 'wrong_password': msg = 'Podano złe hasło'; break;
                case 'no_user': msg = 'Podany użytkownik nie istnieje'; break;
                case 'int_error': msg = 'Bład wewnetrzny'; break;
                case 'already_logged_in': msg = 'Jesteś już zalogowany'; window.location.reload(); break;
                default:
            }
            this.setState({submitButtonValue: 'Zaloguj', alert: {visible: true, value: msg, type: 'warning'}});
        }.bind(this))
            .catch(function (error) {
                console.log(error);
                this.setState({submitButtonValue: 'Zaloguj', alert: {visible: true, value: 'Wystąpił błąd podczas logowania (Err: 001)', type: 'danger'}});
            }.bind(this));
    }

    onDismissAlert() {
        this.setState({ alert: {visible: false }});
    }

    render () {
        return (
            <div style={{display:'flex', justifyContent:'center', alignItems:'center',width:'100%',height:'100%'}}>
                <div className="loginPrompt" style={{color: '#FFF'}}>
                    <Alert color={this.state.alert.type} isOpen={this.state.alert.visible} toggle={this.onDismissAlert}>
                        {this.state.alert.value}
                    </Alert>

                    <h1 className="display-5 text-center" style={{fontWeight: 200}}>Logowanie</h1>
                    <Form>
                        <FormGroup>
                            <Label for="email">Email</Label>
                            <Input type="email" name="email" id="email" onChange={e => this.updateField(e)}/>
                        </FormGroup>
                        <FormGroup>
                            <Label for="password">Password</Label>
                            <Input type="password" name="password" id="password" onChange={e => this.updateField(e)}/>
                        </FormGroup>
                        <Button className="form-control" onClick={() => this.loginAction()}>{this.state.submitButtonValue}</Button>
                    </Form>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/LoginPrompt.js